import React from "react";
import {withStyles} from "@material-ui/core/styles";

import projectsStyle
	from "assets/jss/material-kit-pro-react/views/sectionsSections/projectsStyle.js";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import intl from 'react-intl-universal';

import SeriesVideoTags from "./VideoTages";

class SeriesInfoItem extends React.Component {
	render() {
		const {classes} = this.props;
		const {data} = this.props;
		return (
			<GridItem xs={12} sm={4} md={4} className={classes.mrAuto}>
				<Card plain className={classes.card2}>
					<a href={"/mockingbird/" + data.id} target={"_blank"}>
						<CardHeader plain image>

							{
								data.gifs === null || data.gifs === undefined || data.gifs.length < 10
									?
									//<div
									// style={{backgroundImage: 'url(https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/empty_gif.gif)',
									// 	height: '270px'
									// }}>


									<div style={{position: 'relative'}}>
										<img
											src='https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/empty_gif.gif'/>
										<div style={{
											position: 'absolute',
											zIndex: 2,
											left: '10px',
											top: '10px'
										}}>
											<b style={{color: '#000'}}>
												{intl.get('no_gif')}
											</b>
										</div>
									</div>

									:
									<img src={data.gifs} alt="..."/>

							}
						</CardHeader>
					</a>
					<CardBody>
						<a href={"/mockingbird/" + data.id} target={"_blank"}>
							<h4 className={classes.cardTitle} style={{color: "#fff"}}>
								{data.title}
							</h4>
						</a>
						<p className={classes.cardDescription}
						   style={{
							   overflow: 'hidden',
							   textOverflow: 'ellipsis',
							   display: '-webkit-box',
							   webkitLineClamp: '2',
							   webkitBoxOrient: 'vertical'
						   }}
						>
							{data.introduction}
						</p>
						<SeriesVideoTags data={data.tags}/>
					</CardBody>
				</Card>
			</GridItem>
		);
	}
}

export default withStyles(projectsStyle)(SeriesInfoItem)